import '@adornis/bh-matching-config/entities/global-config.js';
import '@adornis/bh-matching-export/api/BuddyExportAPI.js';
import '@adornis/bh-matching-export/db/BuddyExportDataView.js';
import '@adornis/bh-matching-mails/entities/attachment.js';
import '@adornis/bh-matching-mails/entities/mail-templates.js';
import '@adornis/bh-matching-matches/api/matchAPI.js';
import '@adornis/bh-matching-matches/entities/match.js';
import '@adornis/bh-matching-timeframes/api/MatchingTimeframeAPI.js';
import '@adornis/bh-matching-user/api/MatchingUserAPI.js';
import '@adornis/bh-matching-user/api/registerAdminUser.js';
import '@adornis/bh-matching-user/entities/buddy-user.js';
import '@adornis/bh-timeframes/api/TimeframeAPI.js';
import '@adornis/file-utils/db/index.js';
import '@adornis/users/db/a-user.js';
import '../entities/matching-user.js';
import '../translations.js';
import './auto-matching.js';
import './test-data.js';
import { setUserClass } from '@adornis/bh-matching-user/user-class.js';
import { MatchingHautnahMenteeUser, MatchingHautnahMentorUser } from '../entities/matching-user.js';

setUserClass({
  mentee: MatchingHautnahMenteeUser,
  mentor: MatchingHautnahMentorUser,
});
import '@adornis/bh-matching-timeframes/api/index.js';
import '@adornis/bh-matching-config/api/index.js';
import '@adornis/bh-timeframes/api/index.js';
import '@adornis/bh-matching-matches/api/index.js';
import '@adornis/bh-matching-export/api/index.js';
import '@adornis/bh-debug/api/index.js';
import '@adornis/bh-matching-mails/api/index.js';
import '@adornis/bh-matching-user/api/index.js';
import '@adornis/bh-plugin-impl/api/index.js';
import '@adornis/buchungsheld-db/api/index.js';
